import { c as _c } from "react/compiler-runtime";
import { Form, type TemplateInputProps } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { useAutoDataIdentifier } from '../../../hooks/use-auto-data-identifier';
import type { CustomQuestionsFormData } from '../../../types';
import DataIdentifierField from '../data-identifier-field';
type CheckboxFormProps = {
  questionIndex: number;
  autocompleteItems?: TemplateInputProps['autocompleteItems'];
};
const CheckboxForm = t0 => {
  const $ = _c(33);
  const {
    questionIndex,
    autocompleteItems
  } = t0;
  const {
    t
  } = useTranslation("playbook-custom-questions");
  useAutoDataIdentifier(questionIndex);
  const t1 = `questions.${questionIndex}.label`;
  let t2;
  if ($[0] !== t) {
    t2 = t(_temp);
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp2);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== autocompleteItems) {
    t4 = autocompleteItems ?? {};
    $[4] = autocompleteItems;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <Form.TemplateInput name={t1} label={t2} placeholder={t3} size="compact" autocompleteItems={t4} />;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp3);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp4);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp5);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = {
      text: t8
    };
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== questionIndex || $[20] !== t6 || $[21] !== t7 || $[22] !== t9) {
    t10 = <DataIdentifierField questionIndex={questionIndex} label={t6} placeholder={t7} tooltip={t9} />;
    $[19] = questionIndex;
    $[20] = t6;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const t11 = `questions.${questionIndex}.required`;
  let t12;
  if ($[24] !== t) {
    t12 = t(_temp6);
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <Form.Toggle name={t11} label={t12} size="compact" />;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t10 || $[30] !== t13 || $[31] !== t5) {
    t14 = <div className="flex flex-col gap-6">{t5}{t10}{t13}</div>;
    $[29] = t10;
    $[30] = t13;
    $[31] = t5;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  return t14;
};
export default CheckboxForm;
function _temp($) {
  return $.form.label;
}
function _temp2($_0) {
  return $_0.form.labelPlaceholder;
}
function _temp3($_1) {
  return $_1.form.dataIdentifier;
}
function _temp4($_2) {
  return $_2.form.dataIdentifierPlaceholder;
}
function _temp5($_3) {
  return $_3.form.dataIdentifierTooltip;
}
function _temp6($_4) {
  return $_4.form.required;
}